import { render, staticRenderFns } from "./tabBooking.vue?vue&type=template&id=a4b6b8c6&scoped=true&"
import script from "./tabBooking.vue?vue&type=script&lang=js&"
export * from "./tabBooking.vue?vue&type=script&lang=js&"
import style0 from "./tabBooking.vue?vue&type=style&index=0&id=a4b6b8c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b6b8c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCard,VCol,VRow})
